import { render, staticRenderFns } from "./DriverModal.vue?vue&type=template&id=b28489b6&scoped=true"
import script from "./DriverModal.vue?vue&type=script&lang=js"
export * from "./DriverModal.vue?vue&type=script&lang=js"
import style0 from "./DriverModal.vue?vue&type=style&index=0&id=b28489b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28489b6",
  null
  
)

export default component.exports